import { GeneratorEndpoints, IGensetInfo } from '@scaleaq/sitecontrol-lib';

import { API_NAMES, CACHE_KEYS } from '@/constants';
import {
  useAuthApiDeleteById,
  useAuthApiGetSingleFetch,
  useAuthApiPost,
  type ServiceQueryOptions,
} from '@/dataAccess/rest/apiHooks';

export const useGetGeneratorDevices = ({ enabled }: ServiceQueryOptions = {}) => {
  return useAuthApiGetSingleFetch<IGensetInfo[]>({
    baseApiRoute: API_NAMES.generatorApi,
    cacheKeys: [CACHE_KEYS.generatorsApi],
    route: GeneratorEndpoints.getDevices,
    enabled,
  });
};
export const useAddGeneratorDevice = (deviceIdentifier: string | undefined) => {
  return useAuthApiPost({
    baseApiRoute: API_NAMES.generatorApi,
    route: GeneratorEndpoints.addDevice,
    cacheKeys: [CACHE_KEYS.generatorsApi],
    identifier: deviceIdentifier,
  });
};

export const useRemoveGeneratorDevice = (identifier?: string) => {
  return useAuthApiDeleteById<IGensetInfo & { id: string }>({
    baseApiRoute: API_NAMES.generatorApi,
    cacheKeys: [CACHE_KEYS.generatorsApi],
    identifier: identifier,
    route: GeneratorEndpoints.deleteDeviceById,
  });
};
